import { render, staticRenderFns } from "./job-info.vue?vue&type=template&id=4eb03dac&"
import script from "./job-info.vue?vue&type=script&lang=js&"
export * from "./job-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb03dac')) {
      api.createRecord('4eb03dac', component.options)
    } else {
      api.reload('4eb03dac', component.options)
    }
    module.hot.accept("./job-info.vue?vue&type=template&id=4eb03dac&", function () {
      api.rerender('4eb03dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/job-info.vue"
export default component.exports